import { render, staticRenderFns } from "./ModalCategorySetting.vue?vue&type=template&id=3a1065df&scoped=true"
import script from "./ModalCategorySetting.vue?vue&type=script&lang=js"
export * from "./ModalCategorySetting.vue?vue&type=script&lang=js"
import style0 from "./ModalCategorySetting.vue?vue&type=style&index=0&id=3a1065df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1065df",
  null
  
)

export default component.exports